import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import BackButton from '../../components/BackButton';
import api from '../../services/api';
import './ChatRooms.css';

const ChatRooms = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [rooms, setRooms] = useState([]);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [roomName, setRoomName] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadRooms();
  }, []);

  const loadRooms = async () => {
    try {
      const response = await api.get('/api/chat/rooms/my-rooms');
      setRooms(response.data);
    } catch (error) {
      console.error('Error loading rooms:', error);
    } finally {
      setLoading(false);
    }
  };

  const createRoom = async (e) => {
    e.preventDefault();
    if (!roomName.trim()) return;

    try {
      await api.post('/api/chat/rooms/create', {
        roomName,
        description
      });
      setRoomName('');
      setDescription('');
      setShowCreateForm(false);
      loadRooms();
    } catch (error) {
      alert(error.response?.data?.error || 'Failed to create room');
    }
  };

  const isPremium = user?.roles?.includes('ROLE_PREMIUM');

  if (!isPremium) {
    return (
      <div className="chat-rooms">
        <BackButton />
        <div className="premium-required">
          <h2>Premium Feature</h2>
          <p>Chat rooms are only available for premium members.</p>
          <p>Upgrade to premium to create and join chat rooms!</p>
        </div>
      </div>
    );
  }

  return (
    <div className="chat-rooms">
      <BackButton />
      <div className="chat-rooms-container">
        <div className="rooms-header">
          <h1>Chat Rooms</h1>
          <button onClick={() => setShowCreateForm(!showCreateForm)} className="btn-create">
            {showCreateForm ? 'Cancel' : '+ Create Room'}
          </button>
        </div>

        {showCreateForm && (
          <form onSubmit={createRoom} className="create-room-form">
            <input
              type="text"
              placeholder="Room Name"
              value={roomName}
              onChange={(e) => setRoomName(e.target.value)}
              required
              className="form-input"
            />
            <textarea
              placeholder="Description (optional)"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="form-textarea"
            />
            <button type="submit" className="btn-submit">Create Room</button>
          </form>
        )}

        {loading ? (
          <div className="loading">Loading rooms...</div>
        ) : rooms.length === 0 ? (
          <div className="no-rooms">
            <p>You're not a member of any chat rooms yet.</p>
            <p>Create one to get started!</p>
          </div>
        ) : (
          <div className="rooms-grid">
            {rooms.map(room => (
              <div key={room.id} className="room-card">
                <h3>{room.roomName}</h3>
                <p className="room-description">{room.description}</p>
                <div className="room-info">
                  <span>Created by: {room.createdBy}</span>
                  <span>Members: {room.members?.length || 0}</span>
                </div>
                <button
                  onClick={() => navigate(`/chat/room/${room.id}`)}
                  className="btn-join"
                >
                  Join Room
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatRooms;

